import 'jquery'

$(() => {
  $('a.more-link').wrap('<div class="read-more-wrapper"></div>')
})
